let missingPartNumber = [];
let currentElement;
let selectedAddress;
let reasonOfReplacement;
let address = {}

class subscriptionLandingPage {
    constructor() {
      this._showModal();
      try{
        this._validatePurchase();
      }catch{}
        // Allow the slider videos to initialize on the subscription landing page (page.subscription-landing)
        const shouldInitVideos = window.globalVariables.template != 'page' || window.globalVariables.templateSuffix == 'subscription-landing';

        if (shouldInitVideos) {
            this._checkCurrentBox();
            [].slice.call(document.querySelectorAll("[video-section]")).map(currentEle => {
                let videoType = currentEle.getAttribute('video-type');
                let desktopId = currentEle.getAttribute('data-video-id');
                let mobileId = currentEle.getAttribute('data-mobile-video-id');
                desktopId = desktopId.trim();
                mobileId = mobileId.trim();
                let videoElement = this._buildVideo(desktopId, mobileId, videoType);
                let videoSection = currentEle.parentNode.querySelector("[data-video-section]");
                videoSection.appendChild(videoElement);
            })
        }
    };

    _validatePurchase() {
      let button = document.querySelector('.js-validatePurchase');

      button.addEventListener('click', (event) => {
        event.preventDefault();

        let spinner = button.querySelector('.spinner');
        let textEl = button.querySelector('.d-flex');

        spinner.classList.remove('d-none');
        textEl.classList.add('d-none');

        fetch(`${window.location.origin}/account?view=order-list.json`)
        .then(response => {
          return response.text();
        })
        .then(response => {
          let responseText = response.trim().replace(/,(\s*])/, '$1');
          let arrayText = JSON.parse(responseText);
          let spareTitle = document.querySelector('.js-spareTitle').dataset.id;
          let productFound = arrayText.some(item => {
            return item.includes(spareTitle) ? true : false
          });

          spinner.classList.add('d-none');
          textEl.classList.remove('d-none');
          productFound ? window.location.href = button.getAttribute('href') : this._openPopup();
          
        })
      })
    }

    _openPopup() {
      let modalIdentifier = 'dne'
      let modalEle = document.getElementById(modalIdentifier);
      openModal(modalEle, modalEle);
    }

    _showModal(){
      let hash = window.location.hash;
      console.log(hash);

      if(hash.includes('#dne')) {
        this._openPopup();
      }
    }

    _checkCurrentBox() {
        let subscriptionBoxProduct = JSON.parse(document.querySelector('[data-unlock-boxes]').innerText);
        let productId = document.querySelector("[product_Id]");
        productId = productId.getAttribute("product_Id");
        let flag = false;
        //  document.querySelector("[show-message]").classList.add("d-none");
        //  document.querySelector("[check-current-product]").classList.remove("d-none");

        // subscriptionBoxProduct.forEach(ele=>{
        //  let productid = ele["product_id"];
        //  if(productid == productId){
        //     flag = true;
        //  }
        // })
        // if (flag == true) {
        //     document.querySelector("[show-message]").classList.add("d-none");
        //     document.querySelector("[check-current-product]").classList.remove("d-none");
        // }
    };


    // build video element    
    _buildVideo(videoId, mobileId, type) {
        let video;
        if (window.screen.width <= 767) {
            videoId = mobileId;
        }
        if (type == 'youtube') {
            video = document.createElement("iframe");
            video.setAttribute("allowfullscreen", "");
            video.setAttribute("frameborder", "0");
            video.setAttribute("class", "w-100");
            video.setAttribute("src", "https://www.youtube.com/embed/" + videoId + `?rel=0&showinfo=0&autoplay=false&mute=false&controls=true&loop=true&playlist=${videoId}&enablejsapi=1&origin=${window.origin}`);
        } else {
            video = document.createElement('video');
            video.src = videoId;
            video.autoplay = true;
            video.controls = true;
            video.muted = false;
            video.loop = true;
            video.playsinline;
        }
        return video;
    };

}

new subscriptionLandingPage()
